import * as React from 'react';
export const useSwiperSlide = ({ initialSwiper } = {}) => {
    const [swiper, setSwiper] = React.useState(initialSwiper);
    const [swiperSlide, setSwiperSlide] = React.useState(0);
    React.useEffect(() => {
        if (swiper) {
            swiper.on('slideChange', () => {
                setSwiperSlide(swiper.realIndex);
            });
        }
    }, [swiper]);
    const setSlide = React.useCallback((newSlide) => {
        if (swiper) {
            swiper.slideTo(newSlide);
        }
    }, [swiper]);
    return {
        swiperSlide,
        setSwiper,
        setSlide,
        nextSlide: () => setSlide(swiperSlide + 1),
        prevSlide: () => setSlide(swiperSlide - 1),
        onFirstSlide: swiper?.isBeginning,
        onLastSlide: swiper?.isEnd,
    };
};
